module.exports = __webpack_public_path__ + "img/app-store.9eadab8.svg";